import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { getAuthenticatedEntry } from 'configs/AppConfig'

const PublicRoute = () => {

	const { user, token } = useSelector(state => state.auth)

	return token ? <Navigate to={getAuthenticatedEntry(user)} /> : <Outlet/>
}

export default PublicRoute